/**
 * What the edit page sends when an attendance policy is saved.
 *
 * The form holds `""` for a box nobody filled and a select nobody chose, and
 * `null` for a field the policy was stored without. The server reads both as a
 * value — and refuses them: "" is not a number, null is not one of the
 * tardiness types, an approver row added but never chosen is an empty id. Any
 * one of those failed the whole save with a bare "Validation Failed", even
 * when the field was in a section the admin had not touched.
 *
 * Unset means "leave it as it is", so unset values are left out.
 *
 * The assignment rides in the same request. It used to be a second call after
 * the first, each with its own message, which is how one press of Save could
 * report both "updated successfully" and "Validation Failed".
 */

const isUnset = (v) => v === undefined || v === null || v === "";

// The database's own bookkeeping on a nested settings object read back from
// the server — regularization arrives with an `_id` — is not the admin's to
// send, and the server refused it.
const SERVER_KEYS = new Set(["_id", "__v"]);

const clean = (obj) =>
  Object.fromEntries(
    Object.entries(obj || {})
      .filter(([k, v]) => !isUnset(v) && !SERVER_KEYS.has(k))
      .map(([k, v]) => [k, v && typeof v === "object" && !Array.isArray(v) ? clean(v) : v])
  );

export const policyPayload = (policyData = {}, selectedList = {}) => {
  const body = clean(policyData);
  if (Array.isArray(body.approverIds)) body.approverIds = body.approverIds.filter((id) => !isUnset(id));
  if (Array.isArray(body.shifts)) body.shifts = body.shifts.filter((id) => !isUnset(id));
  body.department = (selectedList.department || []).filter((id) => !isUnset(id));
  body.employeeGroup = (selectedList.employeeGroup || []).filter((id) => !isUnset(id));
  return body;
};
